module.exports = "/* p, b {\n    font-family:\"Calibri (Body)\";\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/course-four/course-four.component.css
// module id = ./src/app/course-four/course-four.component.css
// module chunks = main